import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateUser } from "../../models/admin/CreateUser";
import { UpdateUser } from "../../models/admin/UpdateUser";

const RESOURCE_NAME = "user";

const getAll = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}`, requestConfig());
};

const create = (model: CreateUser) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, model, requestConfig());
};

const update = (model: UpdateUser) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${model.Id}`, model, requestConfig());
};

const remove = (id: number) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
};

const permissions = (id: number) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/${id}/permissions`, requestConfig());
}

const userGroups = (id: number) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/${id}/userGroups`, requestConfig());
}

const UsersService = {
  getAll,
  create,
  update,
  remove,
  permissions,
  userGroups,
};
export default UsersService;
